import React, { Component } from 'react';

import {
  Container,
  Row,
  Col,
  Nav,
  NavItem,
  NavLink
} from 'reactstrap';

import find from 'lodash/find';

import PuzzleResults from './PuzzleResults';
import ChooseResults from './ChooseResults';
import ThisOrThatResults from './ThisOrThatResults';
import RatableResults from './RatableResults';
import QAResults from './QAResults';
import AdjoyabilityDial from '../../../shared/components/AdjoyabilityDial';
import Button from '../../../shared/components/Button';
import Link from 'react-router-dom/NavLink';

import { formatDateRange, emojiUrlForRating } from '../../../shared/utils';

import CursorSVG from '../../../shared/assets/cursor.svg';
import FlagSVG from '../../../shared/assets/flag.svg';
import SpeechSVG from '../../../shared/assets/speech.svg';
import TimeSVG from '../../../shared/assets/time.svg';
import PlusSVG from '../../../shared/assets/rounded-add-button.svg';

class CampaignResults extends Component {
  constructor(){
    super();

    this.state = {
      isLoaded:false,
      isShowingExportHelp:false
    };
  }

  componentDidMount(){
    if(this.props.engagements.length > 0 && this.props.engagementKPIs.length > 0){
      this.setState({isLoaded:true});
    } else {
      Promise.all([
        this.props.loadKPIsForCampaign(this.props.campaignId),
        this.props.loadEngagementsForCampaign(this.props.campaignId)
      ])
        .then(() => this.setState({isLoaded:true}))
        .catch((err) => this.handleFailure(err))
    }
  }

  handleFailure(err){}

  handlePrintClick(){
    window.print();
  }

  getSortedEngagementsAndKPIS(){
    return this.props.engagements
      .sort((a,b) => a.ordinal - b.ordinal)
      .map((engagement) => ({
        engagement:engagement,
        kpi:find(this.props.engagementKPIs, (k) => k.engagementId === engagement.id) || null
      }));
  }

  render(){
    const {
      campaignName,
      brandName,
      salesNumber,
      match,
      launchDate,
      endDate,
      totalCompletions,
      totalEngagements,
      totalEngagementsCounted,
      averageTime,
      totalCtaClickCount,
      ctRate,
      campaignUseCTA
    } = this.props;

    const { isLoaded } = this.state;
    const responsesURL = match.url.slice(0,match.url.lastIndexOf('/')) + '/responses',
      reviewURL = match.url.slice(0,match.url.lastIndexOf('/')) + '/review';

    return (
      <Container className='CampaignResultsPrint'>
        <Row>
          <Col xs='8'>
            <br />
            <br />
            <h1>{campaignName}</h1>
            <h5>
              {brandName}
              &nbsp;&nbsp;
              <span style={{color:'#a5a5a5',fontSize:'1.1rem'}}>
                {formatDateRange(launchDate,endDate)}
              </span>
            </h5>
            <h5>Experience <strong>#{salesNumber}</strong></h5>
          </Col>
          <Col xs='4'>
            <br />
            <br />
            <Button
              className='no-print pull-right'
              onClick={() => this.handlePrintClick()}
            >
              <i className='fa fa-print' aria-hidden='true'></i>
              &nbsp;&nbsp;
              Export
            </Button>
          </Col>
        </Row>
        <Row>
          <Col xs='12' className='print-only'>
            <br />
            <hr />
            <br />
          </Col>
        </Row>
        {window.location.pathname.endsWith("responses") && (
        <Row>
          <Col xs='12' className='no-print'>
            <br />
            <Nav tabs className='UnderLineTabs'>
              <NavItem>
                <NavLink
                  tag={Link}
                  to={responsesURL}
                  activeClassName='active'
                >
                  Consumer Responses
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink
                  tag={Link}
                  to={reviewURL}
                  activeClassName='active'
                >
                  Details
                </NavLink>
              </NavItem>
            </Nav>
            <br />
          </Col>
        </Row>
      )}
        <Row className='CampaignStats'>
          <Col xs='12'>
            <br />
            <br />
            <Row>
              <Col className='data-column'>
                <h2>
                  <img src={FlagSVG} width={28} height={28} style={{verticalAlign:'top'}}/>
                  &nbsp;&nbsp;
                  {!isLoaded ? '⏳' : (totalCompletions || 0).toLocaleString()}
                </h2>
                <h6>Completed Experiences</h6>
                <p>Experiences consumers have completed to date</p>
              </Col>
              <Col className='data-column'>
                <h2>
                  <img src={SpeechSVG} width={28} height={28} style={{verticalAlign:'top'}}/>
                  &nbsp;&nbsp;
                  {!isLoaded ? '⏳' : (totalEngagementsCounted || 0).toLocaleString()}
                </h2>
                <h6>Completed Activities</h6>
                <p>Total activities completed to date</p>
              </Col>
              <Col className='data-column'>
                <h2>
                  <img src={TimeSVG} width={28} height={28} style={{verticalAlign:'top'}}/>
                  &nbsp;&nbsp;
                  {!isLoaded ? '⏳' : Math.ceil(averageTime)} sec
                </h2>
                <h6>Average Time Spent in Experience</h6>
                <p>Average time users have spent engaging with you</p>
              </Col>
              {campaignUseCTA && totalCompletions > 0 && (
                <Col className='data-column'>
                  <h2>
                    <img src={CursorSVG} width={28} height={28} style={{verticalAlign:'top'}}/>
                    <div style={{display:'inline-block',width:90}}>
                      &nbsp;
                      {!this.state.isLoaded ? '⏳' : ctRate}%
                    </div>
                  </h2>
                  <h6>Click Through Rate</h6>
                  <p>Percentage of completed experiences that resulted in clicks</p>
                </Col>
              )}
            </Row>
          </Col>
        </Row>

        <Row>
          <Col xs='12'>
            <hr />
          </Col>
        </Row>

        {isLoaded && this.getSortedEngagementsAndKPIS().map((engagementAndKPI) => {
          const e = engagementAndKPI.engagement,
            k = engagementAndKPI.kpi;

          if(!e || !k) return null;

          if(e.kind === 'choose'){
            return (
              <ChooseResults
                key={e.id}
                engagement={e}
                engagementKPIs={k}
              />
            )
          }

          if(e.kind === 'puzzle'){
            return (
              <PuzzleResults
                key={e.id}
                engagement={e}
                engagementKPIs={k}
              />
            )
          }

          if(e.kind === 'this_or_that'){
            return (
              <ThisOrThatResults
                key={e.id}
                engagement={e}
                engagementKPIs={k}
              />
            )
           }

          if(e.kind === 'ratable'){
            return (
              <RatableResults
                key={e.id}
                engagement={e}
                engagementKPIs={k}
              />
            )
          };

          if(e.kind === 'qa'){
            return (
              <QAResults
                key={e.id}
                engagement={e}
                engagementKPIs={k}
              />
            )
          }

          return null;
        })}

        <Row>
          <Col xs='12'>
            <br />
            <br />
            <img
              className='print-only'
              src={require('../../../shared/assets/dabbl-logo.png')}
              alt='Dabbl Logo'
              style={{
                width:75,
                marginLeft:'auto',
                marginRight:'auto',
                display:'block'
              }}
            />
          </Col>
        </Row>
      </Container>
    )
  }
}

export default CampaignResults;



// WEBPACK FOOTER //
// ./src/routes/CampaignResultsPrint/components/CampaignResultsPrint.js